import { render, staticRenderFns } from "./ManageWorkAgentDefinition.vue?vue&type=template&id=0f6c49a6&scoped=true&lang=pug"
import script from "./ManageWorkAgentDefinition.vue?vue&type=script&lang=js"
export * from "./ManageWorkAgentDefinition.vue?vue&type=script&lang=js"
import style0 from "./ManageWorkAgentDefinition.vue?vue&type=style&index=0&id=0f6c49a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6c49a6",
  null
  
)

export default component.exports